import { useEffect } from 'react';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t, i18n } = useTranslation(['cookiebanner']);

  useEffect(() => {
    CookieConsent.reset();

    void CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: 'box inline',
          position: 'bottom right',
        },
      },
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        marketing: {
          enabled: false,
          autoClear: {
            cookies: [{ name: /^_aff/ }, { name: /^_gcl/ }, { name: /^_fbp/ }],
          },
        },
      },
      language: {
        default: i18n.language,
        translations: {
          [i18n.language]: {
            consentModal: {
              title: t('cookiebanner:consentModal.title'),
              description: t('cookiebanner:consentModal.description'),
              acceptAllBtn: t('cookiebanner:consentModal.acceptAllBtn'),
              acceptNecessaryBtn: t(
                'cookiebanner:consentModal.acceptNecessaryBtn'
              ),
              showPreferencesBtn: t(
                'cookiebanner:consentModal.showPreferencesBtn'
              ),
            },
            preferencesModal: {
              title: t('cookiebanner:preferencesModal.title'),
              acceptAllBtn: t('cookiebanner:preferencesModal.acceptAllBtn'),
              acceptNecessaryBtn: t(
                'cookiebanner:preferencesModal.acceptNecessaryBtn'
              ),
              savePreferencesBtn: t(
                'cookiebanner:preferencesModal.savePreferencesBtn'
              ),
              sections: [
                {
                  title: t(
                    'cookiebanner:preferencesModal.sections.necessary.title'
                  ),
                  description: t(
                    'cookiebanner:preferencesModal.sections.necessary.description'
                  ),
                  linkedCategory: 'necessary',
                },
                {
                  title: t(
                    'cookiebanner:preferencesModal.sections.marketing.title'
                  ),
                  description: t(
                    'cookiebanner:preferencesModal.sections.marketing.description'
                  ),
                  linkedCategory: 'marketing',
                },
              ],
            },
          },
        },
      },
      onConsent: () => {
        if (CookieConsent.acceptedCategory('marketing')) {
          loadAffiliateScripts();
        }
      },
      onChange: () => {
        if (CookieConsent.acceptedCategory('marketing')) {
          loadAffiliateScripts();
        }
      },
    });
  }, [i18n.language, t]);

  return null;
};

const loadAffiliateScripts = () => {
  if (!document.getElementById('refindie-script')) {
    const script = document.createElement('script');
    script.id = 'refindie-script';
    script.src = 'https://www.refindie.com/refindie.js';
    script.async = true;
    script.dataset.programId = '241';
    document.head.appendChild(script);
  }
};
